import {
  SUBSCRIBE_CARDS_LOADING,
  SUBSCRIBE_CARDS_LOADED,
  SUBSCRIBE_CARDS_ERROR,
  SUBSCRIBE_RESET_CARDS,
  SET_CURRENT_CARD,
  CLEAR_CURRENT_CARD,
  INIT_SUBSCRIBE,
} from "../types";

//eslint-disable-next-line
export default (state, action) => {
  switch (action.type) {
    case SUBSCRIBE_RESET_CARDS:
      return {
        ...state,
        ...action.payload,
      };
    case SUBSCRIBE_CARDS_LOADING:
      return {
        ...state,
        subscribeLoading: true,
        subscribeLoaded: false,
        error: null,
      };
    case SUBSCRIBE_CARDS_LOADED:
      return {
        ...state,
        subscribeCards: action.payload,
        subscribeLoading: false,
        subscribeLoaded: true,
        changedCards: action.payload.data,
      };
    case INIT_SUBSCRIBE:
      return {
        ...state,
        subscribeRequest: action.payload,
      };
    case SUBSCRIBE_CARDS_ERROR:
      return {
        ...state,
        error: action.payload,
        subscribeLoading: false,
        subscribeLoaded: false,
      };
    case SET_CURRENT_CARD:
      return { ...state, selectedCard: action.payload.card };
    case CLEAR_CURRENT_CARD:
      return { ...state, selectedCard: null };
    default:
      return state;
  }
};
